function RegEmail() {
    /// <summary>
    /// This object provides common functions for the Widget.Membership.RegistrationEmail.vb <br/>
    /// Author: ARF<br />
    /// Date: 25.5.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 31.5.2016                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.uid = -1;
}
RegEmail.prototype = new vcTemplate();

RegEmail.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, click handler and buttons.
    /// </summary>
  var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
      
        me.visual.find('#txtBody').cleditor({
            height: 400, width: 'auto', controls: 'bold italic underline | font size style removeformat | bullets numbering | outdent indent | alignleft center alignright justify | undo redo | rule link unlink | cut copy paste pastetext '
        });
        //load the email content
        me.load();

        me.visual.find("#btnSend").button().off("click").on("click", function() {
            me.send();
        });

        me.visual.find("#ddlLanguage").off("change").on("change",function() { me.load();});
        me.visual.find("#ddlBrands").off("change").on("change", function () { me.load(); });
        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


RegEmail.prototype.load = function () {
    /// <summary>
    /// This function fills the email content. 
    /// </summary>
    var me = this;
    var langid;
    var brand;
    try {
        if (me.error) {
            return false;
        }
        langid = parseInt(me.visual.find("#ddlLanguage").val(), 10);
        brand = me.visual.find("#ddlBrands").val();
       
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({'type':0, 'id': me.id, 'langid': langid, 'brand':brand }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                me.visual.find('#txtSubject').val(result.Subject);
                //set the content and update the cleditor
                me.visual.find('#txtBody').val(result.Body).blur();

                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('reload', ex);
        return false;
    }
};


RegEmail.prototype.send = function () {
    /// <summary>
    /// This function reloads the entry list. 
    /// </summary>
    var me = this;
    var email = {};
    var langid;
    var brand;
    try {
        if (me.error) { return false;}
       
        langid = parseInt(me.visual.find("#ddlLanguage").val(), 10);
        brand = me.visual.find("#ddlBrands").val();
       
        email.subject = me.visual.find("#txtSubject").val(); 
        email.body = me.visual.find("#txtBody").val();
        //email.useMyEmail = me.visual.find("#chbUseMyEmail").is(":checked");
        email.sendEmailtoMe = me.visual.find("#chbSendEmailToMe").is(":checked");
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({'id': me.id, 'langid': langid, 'brand':brand }), '', me.deviceType, me.langid, JSON.stringify(email),
            function (result) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                
                me.showInfo(me.resources.emailSent,"", false);
                me.visual.find('#divSelection,  #txtBody, #btnSend, .info').hide();
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('send', ex);
        return false;
    }
};

RegEmail.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divSelection,  #txtBody, #btnSend, .info').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex);
        return false;
    }
};


// ReSharper disable once UnusedParameter
RegEmail.prototype.doEvent = function (event) {
    return true;
};

